<template>
  <base-info-card title="Top Tags">
    <v-row
      class="mb-10"
      dense
    >
      <v-col
        v-for="tag in tags"
        :key="tag.value"
        cols="auto"
      >
        <v-btn
          class="text-capitalize"
          color="grey darken-2"
          outlined
          tile
          :to="{ name: 'BlogTag', params: { lang: $i18n.locale, slug: tag.value } }"
        >
          {{ tag.label }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- <base-img
      :src="require('@/assets/tags.jpg')"
      color="grey lighten-1"
      height="250"
      tile
      width="100%"
    /> -->
  </base-info-card>
</template>

<script>
  export default {
    name: 'NewsArchives',
    data: () => ({
      tags: [],
    }),

    watch: {
      '$i18n.locale'() {
        this.loadTags()
      },
    },

    async mounted() {
      await this.loadTags()
    },

    methods: {
      async loadTags() {
        try {
          const resp = await this.$axios({ method: 'get', url: '/public/dict/data', params: { dictType: 'sys_blog_tag' } })
          const items = Array.isArray(resp) ? resp : (resp?.data || resp?.items || [])
          this.tags = items.map(item => ({
            label: item.dictLabel,
            value: item.dictValue,
          })).filter(item => item.label && item.value)
        } catch (error) {
          this.tags = []
        }
      },
    },
  }
</script>
